/**
 * API Configuration
 * Central place for all API endpoints and base URLs
 */

// Get base API URL from environment
const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
};

// Get API URL with /api suffix
const getApiUrl = (): string => {
  return import.meta.env.VITE_API_URL || `${getApiBaseUrl()}/api`;
};

// Export configuration object
export const API_CONFIG = {
  // Base URLs
  BASE_URL: getApiBaseUrl(),
  API_URL: getApiUrl(),

  // Specific service URLs
  CV_API_URL: `${getApiUrl()}/cv`,
  INTERVIEW_API_URL: getApiUrl(),
  CONTACT_API_URL: getApiUrl(),
  ASSESSMENT_API_URL: getApiBaseUrl(),

  // Full endpoint builders
  endpoints: {
    // Auth endpoints
    auth: {
      login: `${getApiUrl()}/auth/login`,
      register: `${getApiUrl()}/auth/register`,
      registerWithCv: `${getApiUrl()}/auth/register-with-cv`,
      me: `${getApiUrl()}/auth/me`,
      logout: `${getApiUrl()}/auth/logout`,
      refresh: `${getApiUrl()}/auth/refresh`,
      forgotPassword: `${getApiUrl()}/auth/forgot-password`,
      applications: `${getApiUrl()}/auth/candidates/applications`,
      resetApplications: `${getApiUrl()}/auth/dev/reset-applications`,
    },

    // CV endpoints
    cv: {
      upload: `${getApiUrl()}/cv/upload`,
      analyzeText: `${getApiUrl()}/cv/analyze-text`,
      test: `${getApiUrl()}/cv/test`,
    },

    // Jobs endpoints
    jobs: {
      list: `${getApiUrl()}/jobs`,
      detail: (id: string) => `${getApiUrl()}/jobs/${id}`,
      apply: (id: string) => `${getApiUrl()}/jobs/${id}/apply`,
      applicationStatus: (id: string) => `${getApiUrl()}/jobs/${id}/application-status`,
    },

    // Interview endpoints
    interviews: {
      list: `${getApiUrl()}/interviews/`,
      create: `${getApiUrl()}/interviews/`,
      finish: (id: string) => `${getApiUrl()}/interviews/${id}/finish`,
      results: (id: string) => `${getApiUrl()}/interviews/${id}`,
      unapply: (id: string) => `${getApiUrl()}/interviews/${id}/unapply`,
    },

    // Contact endpoints
    contact: {
      submit: `${getApiUrl()}/contact/`,
      test: `${getApiUrl()}/contact/test`,
      retry: `${getApiUrl()}/contact/retry`,
    }
  }
} as const;

// Export individual URLs for backward compatibility
export const {
  BASE_URL,
  API_URL,
  CV_API_URL,
  INTERVIEW_API_URL,
  CONTACT_API_URL,
  ASSESSMENT_API_URL
} = API_CONFIG;